import { render, staticRenderFns } from "./LedgerDetail.vue?vue&type=template&id=873a4d70"
import script from "./LedgerDetail.vue?vue&type=script&lang=js"
export * from "./LedgerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports